/* eslint-disable react/no-danger */
import './NavHeading.scss';

import React, { FC, useEffect } from 'react';

export interface NavHeadingProps {
  title: string;
  shortDescription?: string;
  helpLink?: string;
  helpLinkText?: string;
  helpLinkCssClass?: string;
  helpIconCssClass?: string;
}

const NavHeading: FC<NavHeadingProps> = ({ title, shortDescription, helpLink, helpLinkText, helpLinkCssClass, helpIconCssClass }) => {

  useEffect(() => {
    document.title = `${title} : BlabberJax Content OS`;
  }, [title]);

  const helpText = helpLinkText || 'Get help';

  if (!shortDescription && !helpLink) {
    return (
      <div className="nav-heading">
        <h1>
          {title}
        </h1>
      </div>
    );
  }

  if (!helpLink) {
    return (
      <div className="nav-heading">
        <h1>
          {title}
        </h1>
        <div className="row desc">
          <div className="col-md-12 gx-0 test" dangerouslySetInnerHTML={{ __html: shortDescription || '' }} />
        </div>
      </div>
    );
  }

  return (
    <div className="nav-heading">
      <h1>
        {title}
      </h1>
      <div className="row desc">
        <div className="col-10 gx-0">
          <div className="" dangerouslySetInnerHTML={{ __html: shortDescription || '' }} />
          <a href={helpLink} target="_blank" rel="noreferrer" className={helpLinkCssClass}>
            {helpIconCssClass && <i className={helpIconCssClass} style={{ marginRight: '0.5em' }} />}
            {helpText}
          </a>
        </div>
      </div>
    </div>
  );
}

export default NavHeading;
